import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import { useState } from 'react';

interface ItemType {
    img: [string, string];
    name: string;
    text: string;
    tab: string;
    desc: string;
    memo?: string;
}
const L: React.FC = () => {
    const { t } = useLang('d3u');
    const [active, setActive] = useState<number>(0);
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760927557740/12_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760927557539/12_1_M.jpg'],
            tab: t('L_item1_tab'),
            name: t('L_item1_name'),
            text: t('L_item1_text'),
            desc: 'L_item1_desc',
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760927558000/12_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760927559988/12_2_M.jpg'],
            tab: t('L_item2_tab'),
            name: t('L_item2_name'),
            text: t('L_item2_text'),
            desc: 'L_item2_desc',
            memo: t('L_item2_memo'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760927558509/12_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760927559501/12_3_M.jpg'],
            tab: t('L_item3_tab'),
            name: t('L_item3_name'),
            text: t('L_item3_text'),
            desc: 'L_item3_desc',
            memo: t('L_item3_memo'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760927558969/12_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760927560352/12_4_M.jpg'],
            tab: t('L_item4_tab'),
            name: t('L_item4_name'),
            text: t('L_item4_text'),
            desc: 'L_item4_desc',
            memo: t('L_item4_memo'),
        },
    ];

    const handleChangeTab = (tx: string, k: number) => {
        if (active !== k) {
            setActive(k);
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: t('L_title'),
                button_name: tx,
                __btn_id1: `${css.section} .tab-${k + 1}`,
                __btn_id2: tx,
                __btn_type: 'text',
            });
            const parent: HTMLUListElement | null = document.querySelector('.D3U-L .tabs');
            if (k > items.length / 2 && parent) {
                parent.scrollTo({
                    left: parent.scrollWidth / 2,
                    behavior: 'smooth',
                });
            } else if (k <= items.length / 2 && parent) {
                parent.scrollTo({
                    left: 0,
                    behavior: 'smooth',
                });
            }
        }
    };

    return (
        <section className={`${css.section} D3U-L GtmModuleData-section`} id="D3U-L" data-section-id={'D3U-L'} data-section-id2={t('L_title')}>
            <div className="info">
                <p className="label">{t('L_label')}</p>
                <p className="title">{t('L_title')}</p>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="img">
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                            <p className="item-desc">
                                {t.rich(item.desc, {
                                    b: (tx: string) => <span className="b">{tx}</span>,
                                })}
                            </p>
                        </div>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                            {item.memo && <p className="memo">{item.memo}</p>}
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items.map((item: ItemType, k: number) => (
                    <li
                        className={`tab${active === k ? ' active' : ''} tab-${k + 1} GtmModuleData-btn-text`}
                        key={k}
                        onClick={() => handleChangeTab(item.tab, k)}
                    >
                        <p className="name">{item.tab}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default L;
